import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Simulate API call
        setTimeout(() => {
            toast.success('Thank you for your message! We will get back to you soon.');
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
            setSubmitted(true);
            setLoading(false);

            setTimeout(() => setSubmitted(false), 3000);
        }, 1500);
    };

    const contactInfo = [
        { icon: FaPhone, title: "Phone", details: ["+44 77479 57293"] },
        { icon: FaEnvelope, title: "Email", details: ["titanforgemetals@gmail.com"] },
        { icon: FaMapMarkerAlt, title: "Visit Us", details: ["4, Speidhurst Road, Tunbridge Wells, TN4 ODP"] },
        { icon: FaClock, title: "Business Hours", details: ["Mon-Sat: 10am - 6pm"] }
    ];

    const faqs = [
        { q: "How long does shipping take?", a: "Standard shipping takes 3-5 business days. Express shipping available for 1-2 business days." },
        { q: "What is your return policy?", a: "We offer a 30-day return policy for unused items in original packaging." },
        { q: "Do you offer wholesale pricing?", a: "Yes, please contact our wholesale team at wholesale@tfmtoys.com for pricing." },
        { q: "Are your toys safe for children?", a: "Absolutely! All our toys meet or exceed international safety standards." }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <div className="relative bg-gradient-to-r from-purple-600 to-pink-600 py-24 overflow-hidden">
                <div className="absolute inset-0 bg-black/20"></div>
                <div className="relative container mx-auto px-4 text-center text-white">
                    <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-fade-in-up">
                        Contact Us
                    </h1>
                    <p className="text-xl md:text-2xl opacity-90 animate-fade-in-up animation-delay-200">
                        We'd love to hear from you!
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-16">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Contact Information */}
                    <div className="lg:col-span-1 space-y-6">
                        {contactInfo.map((info, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition group">
                                <div className="flex items-start gap-4">
                                    <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-3 rounded-full group-hover:scale-110 transition">
                                        <info.icon className="text-white text-xl" />
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="font-semibold text-gray-800 text-lg mb-2">{info.title}</h3>
                                        {info.details.map((detail, idx) => (
                                            <p key={idx} className="text-gray-600">{detail}</p>
                                        ))}
                                        <p className="text-sm text-gray-500 mt-1">{info.sub}</p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Social Media */}
                        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl p-6 text-white">
                            <h3 className="font-semibold text-xl mb-4">Follow Us</h3>
                            <div className="flex gap-4">
                                <a href="#" className="bg-white/20 p-3 rounded-full hover:bg-white/30 transition transform hover:scale-110">
                                    <FaFacebook />
                                </a>
                                <a href="#" className="bg-white/20 p-3 rounded-full hover:bg-white/30 transition transform hover:scale-110">
                                    <FaTwitter />
                                </a>
                                <a href="#" className="bg-white/20 p-3 rounded-full hover:bg-white/30 transition transform hover:scale-110">
                                    <FaInstagram />
                                </a>
                                <a href="#" className="bg-white/20 p-3 rounded-full hover:bg-white/30 transition transform hover:scale-110">
                                    <FaLinkedin />
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-xl shadow-md p-6 md:p-8">
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Send Us a Message</h2>
                            <p className="text-gray-600 mb-6">We'll get back to you within 24 hours</p>

                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                                            Your Name *
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
                                            placeholder="John Doe"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                            Email Address *
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
                                            placeholder="john@example.com"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                                        Subject *
                                    </label>
                                    <input
                                        type="text"
                                        id="subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
                                        placeholder="How can we help you?"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                                        Message *
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="6"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition resize-none"
                                        placeholder="Please describe your question or concern..."
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    disabled={loading || submitted}
                                    className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                                >
                                    {loading ? (
                                        <>
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                            Sending...
                                        </>
                                    ) : submitted ? (
                                        <>
                                            <FaCheckCircle /> Sent Successfully!
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane /> Send Message
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* FAQ Section */}
                <div className="mt-16">
                    <div className="text-center mb-10">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Frequently Asked Questions</h2>
                        <div className="w-24 h-1 bg-purple-600 mx-auto rounded-full"></div>
                        <p className="text-gray-600 mt-4">Find quick answers to common questions</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                        {faqs.map((faq, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition group">
                                <h3 className="font-semibold text-gray-800 text-lg mb-2 group-hover:text-purple-600 transition">
                                    {faq.q}
                                </h3>
                                <p className="text-gray-600">{faq.a}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <div className="bg-gray-100 py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Find Us Here</h2>
                    <div className="rounded-2xl overflow-hidden shadow-xl">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.2219901290355!2d-74.00369368400567!3d40.71312937933077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a316bb2d8b9%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1644262072643!5m2!1sen!2sus"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            title="Store Location"
                            className="w-full"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;